import { createVNode as _createVNode } from "vue";
/**
 * @author wuluoting
 * @fileoverview 下拉组件
 */

import { defineComponent, ref, Transition } from "vue";
// hooks
// config

// context

// components

export default defineComponent({
  name: "SelectBtn",
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultOption: {
      type: Object,
      required: false,
      default: null
    },
    dataValue: {
      type: Number,
      required: false,
      default: null
    },
    style: {
      type: Object,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  setup(props, {
    emit
  }) {
    const showDropdown = ref(true);
    const selectedOption = ref(props.defaultOption || props.options[0]);
    const toggleDropdown = () => {
      if (props.disabled) return;
      showDropdown.value = !showDropdown.value;
    };
    const selectOption = option => {
      selectedOption.value = option;
      showDropdown.value = true;
      emit("click", selectedOption.value);
    };
    function buttonUrl() {
      let img = "";
      props.options.forEach(item => {
        if (props.dataValue === item.value) {
          img = item.image;
        }
      });
      return props.dataValue ? img : props.options[0].image;
    }
    return () => {
      return _createVNode("div", {
        "class": "dropdown pc-explain"
      }, [_createVNode("img", {
        "class": "dropdown-button",
        "src": require(`@/assets/img/${buttonUrl()}`),
        "onClick": toggleDropdown,
        "style": props.style
      }, null), _createVNode(Transition, {
        "name": "fade"
      }, {
        default: () => [_createVNode("div", {
          "class": ["dropdown-menu", showDropdown.value && "none"]
        }, [props.options.map((option, index) => _createVNode("div", {
          "class": "dropdown-li",
          "key": index,
          "onClick": () => selectOption(option)
        }, [option.label, _createVNode("div", {
          "class": "line"
        }, null)]))])]
      })]);
    };
  }
});